module.exports = __webpack_public_path__ + "img/433D3F_A58D7D_786760_8C7C6D-256px.24f6ae1f.png";